/**
 * Removes HTML tags from the string and checks if the input is a valid string.
 *
 * @param {any} string - The input value that may contain HTML.
 * @returns {string} - The cleaned string with HTML tags removed.
 */
export default function removeHtmlTags(string) {
  if (typeof string !== 'string') {
    return '';
  }
  return string?.replace(/<\/?[^>]+(>|$)/g, '');
}
